import React from "react";
import { Box } from "@chakra-ui/react";
import { useIndustry } from "./tokens";

export type TagVariant = "accent" | "neutral" | "outline";

interface TagProps {
  variant?: TagVariant;
  title?: string;
  children: React.ReactNode;
}

/**
 * Status tag — 11px, 3px 10px, square. accent = positive, neutral = in
 * progress / pending, outline = knockout / warning. Never green/amber/red
 * (handoff/README.md rule 1).
 */
export const Tag: React.FC<TagProps> = ({ variant = "neutral", title, children }) => {
  const t = useIndustry();
  const styles =
    variant === "accent"
      ? { bg: t.accent200, color: t.steelRule, borderColor: t.accent200 }
      : variant === "outline"
        ? { bg: "transparent", color: t.text, borderColor: t.mark }
        : { bg: t.surface, color: t.muted, borderColor: t.surface };
  return (
    <Box
      as="span"
      display="inline-block"
      fontSize="11px"
      lineHeight="16px"
      fontWeight={500}
      px="10px"
      py="3px"
      borderWidth="1px"
      borderStyle="solid"
      borderRadius={0}
      whiteSpace="nowrap"
      title={title}
      {...styles}
    >
      {children}
    </Box>
  );
};
